/*
* <license header>
*/

import React from 'react'
import { Heading, View } from '@adobe/react-spectrum'
export const Home = () => (
  <View width='size-6000'>
    <Heading level={1}>Welcome to aikappfunction!</Heading>
  </View>
)
